import { Dispatcher } from 'flux';

const appDispatcher = new Dispatcher();
export default appDispatcher;
